module.exports = __webpack_public_path__ + "static/img/bcg_anim_t.30ccebc8.png";